import {Component, ContentChildren, HostBinding, Input, QueryList} from "@angular/core";
import {FUIContentLayoutHeaderControlComponent} from "../../header-control/content-layout-header-control.component";

@Component({
    selector: "fui-column",
    styleUrls: ["./column.component.scss"],
    templateUrl: "./column.component.html",
    standalone: false
})
export class FUIColumnComponent {
    @ContentChildren(FUIContentLayoutHeaderControlComponent, {descendants: false}) public headerControl: QueryList<FUIContentLayoutHeaderControlComponent>;
    @HostBinding("class.labelled") @Input() public label: string;
    @HostBinding("class.bordered") @Input() bordered: boolean;
    @Input() i18nParams: any = {};
    @Input() hideContent: boolean = false;
}
